"use client";

import { useClerk } from "@clerk/nextjs";
import { useRouter } from "next/navigation";
import { getCookie } from "@cappelendamm/cookie";

/**
 * Sends the user to sign in. Sign-in happens on the primary domain, so the
 * current universe is added to the path to brand the page and lead back here.
 */
export function useSignInRedirect({ returnHere = false } = {}) {
  const clerk = useClerk();
  const router = useRouter();

  return () => {
    const signInUrl = new URL(
      clerk.buildSignInUrl(
        returnHere
          ? {
              signInForceRedirectUrl: window.location.href,
              signUpForceRedirectUrl: window.location.href,
            }
          : undefined,
      ),
    );

    const currentUniverseTag = getCookie("universe");
    if (currentUniverseTag) {
      signInUrl.pathname += `/${currentUniverseTag}`;
    }

    router.replace(signInUrl.href);
  };
}
